import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useAuthStore } from '@/lib/auth'

function useBillingOwner() {
  const { user, isAuthenticated } = useAuthStore()
  return isAuthenticated && user?.role !== 'sre' ? user?.uuid || user?.id || null : null
}

// Share the completed response as well as in-flight work across the header and
// dashboard. Account identity is part of the key; never reuse another owner's data.
export function useBillingEstimate() {
  const owner = useBillingOwner()
  return useQuery({
    queryKey: ['account-billing', 'estimate', owner],
    queryFn: () => apiClient.getBillingEstimate(),
    enabled: owner !== null,
    staleTime: 60_000,
    refetchInterval: 10 * 60_000,
    retry: false,
  })
}

export function useBillingCredits() {
  const owner = useBillingOwner()
  return useQuery({
    queryKey: ['account-billing', 'credits', owner],
    queryFn: () => apiClient.getBillingCredits(),
    enabled: owner !== null,
    staleTime: 60_000,
    retry: false,
  })
}
